import { postErrorToServer, userAction } from '@/util/helpers/ajax-helpers';
import UserNotLoggedInException from '../util/UserNotLoggedInException';
import BadRequestException from '../util/BadRequestException';

import {
  LOADING,
  FAILED,
  EXCEPTION,
  FINISHED,
  USER_NOT_LOGGED_IN,
} from './constants';

/**
 * Helper functions
 */

export function loading(actionType, meta = {}) {
  return {
    type: LOADING,
    awaiting: actionType,
    meta,
  };
}

export function failed(actionType, error) {
  window.console.error(`Failed ${actionType}`, error);
  if (error.stack) {
    window.console.error(error.stack);
    postErrorToServer(error.stack);
  } else {
    window.console.error(
      'NOTE: running on dev server, so stack not posted to server!',
    );
  }
  return {
    type: FAILED,
    awaiting: actionType,
    error,
  };
}

export function completed(actionType, payload = {}) {
  return {
    type: actionType,
    payload,
  };
}

export function finished(actionType, payload = {}) {
  return {
    type: FINISHED,
    awaiting: actionType,
    payload,
  };
}

/**
 * These are expected exceptions, that happen in day-to-day use of Trevor
 *  (e.g. timeouts and broken layers, etc.)
 */
export function exception(actionType, userMsg, payload = {}) {
  return {
    type: EXCEPTION,
    userMsg,
    awaiting: actionType,
    payload,
  };
}

export function standardErrorHandler(actionType, dispatch) {
  return (error) => {
    if (error instanceof UserNotLoggedInException) {
      dispatch(failed(actionType, error)); // still dispath failed, as we want the loading bars to stop
      setTimeout(() => {
        dispatch(completed(USER_NOT_LOGGED_IN)); // now re-auth dialog
      }, 1000); // add a delay, as if user has clicked save on a modal, we want to let the modal close itself first (and want to let the 'failed' action finish too)
      return;
    }
    if (error instanceof BadRequestException) {
      error
        .response()
        .json()
        .then(function (json) {
          switch (json._reason) {
            case 'EXECUTION_CANCELLED':
            // if it gets here it is because it is the latest query, so must be a forced timeout
            // so fallthrough!
            case 'QUERY_TIMED_OUT':
              dispatch(
                exception(
                  actionType,
                  'Request timed out. Please try again or adjust your query.\nNote: this error also happens if you have Trevor open in another browser tab.\nIf this problem persists, please contact us.',
                ),
              );
              return;
            case 'LIMITS_EXCEEDED':
              userAction('seen-error-limits_exceeded');
            // fallthrough
            case 'USER_ERROR': {
              dispatch(exception(actionType, json._msg));
              return;
            }
            case 'BAD_QUERY_LAYER':
              dispatch(
                exception(actionType, json._msg, { layerId: json._layerId }),
              );
              return;
            case 'START_FROM_SAVED_QUERY_CYCLIC_DEPENDENCY':
              dispatch(
                exception(actionType, json._msg, { layerId: json._layerId }),
              );
              return;
            case 'INCONSISTENT_MODEL': {
              const msg =
                `Database metadata seems to be out-of-date.` +
                `\nTo fix this, click the Gear icon in the bottom left and click 'Refresh tables metadata'. ` +
                `Alternatively go to 'Configure table access', or reach out to us if the problem persists.\n---\n${json._msg}`;
              dispatch(exception(actionType, msg));
              return;
            }
            default:
              throw new Error(`Unexpected error reason: ${json._reason}`);
          }
        });
      return;
    }
    dispatch(failed(actionType, error));
  };
}
